export default __webpack_public_path__ + "static/media/all2.dd304743.gif";